import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Search, Filter, ChevronDown, MoreHorizontal } from 'lucide-react';
import { StatusBadge } from '../components/StatusBadge';
interface ProductsProps {
  onProductClick: (id: number) => void;
}
export function Products({
  onProductClick
}: ProductsProps) {
  const [searchTerm, setSearchTerm] = useState('');
  const products = [{
    id: 1,
    name: 'Smart TV Samsung 55" 4K',
    category: 'Eletrônicos',
    price: 2899.0,
    marketAvg: 2750.0,
    diff: 5.4,
    status: 'acima' as const
  }, {
    id: 2,
    name: 'iPhone 14 128GB',
    category: 'Eletrônicos',
    price: 4199.0,
    marketAvg: 4250.0,
    diff: -1.2,
    status: 'abaixo' as const
  }, {
    id: 3,
    name: 'Geladeira Brastemp Frost Free',
    category: 'Eletrodomésticos',
    price: 3499.0,
    marketAvg: 3499.0,
    diff: 0.0,
    status: 'dentro' as const
  }, {
    id: 4,
    name: 'Notebook Dell Inspiron 15',
    category: 'Informática',
    price: 3899.0,
    marketAvg: 4100.0,
    diff: -4.9,
    status: 'abaixo' as const
  }, {
    id: 5,
    name: 'Air Fryer Mondial 4L',
    category: 'Eletroportáteis',
    price: 399.0,
    marketAvg: 350.0,
    diff: 14.0,
    status: 'acima' as const
  }, {
    id: 6,
    name: 'Console PlayStation 5',
    category: 'Games',
    price: 3699.0,
    marketAvg: 3699.0,
    diff: 0.0,
    status: 'dentro' as const
  }, {
    id: 7,
    name: 'Cafeteira Nespresso Essenza',
    category: 'Eletroportáteis',
    price: 449.0,
    marketAvg: 480.0,
    diff: -6.5,
    status: 'abaixo' as const
  }, {
    id: 8,
    name: 'Monitor LG Ultrawide 29"',
    category: 'Informática',
    price: 1299.0,
    marketAvg: 1150.0,
    diff: 12.9,
    status: 'acima' as const
  }, {
    id: 9,
    name: 'Micro-ondas Electrolux 34L',
    category: 'Eletrodomésticos',
    price: 699.0,
    marketAvg: 720.0,
    diff: -2.9,
    status: 'abaixo' as const
  }, {
    id: 10,
    name: 'Soundbar JBL Cinema',
    category: 'Áudio',
    price: 999.0,
    marketAvg: 999.0,
    diff: 0.0,
    status: 'dentro' as const
  }];
  const filteredProducts = products.filter(p => p.name.toLowerCase().includes(searchTerm.toLowerCase()) || p.category.toLowerCase().includes(searchTerm.toLowerCase()));
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.3
  }} className="space-y-6" data-id="element-297">
      <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-298">
        <div data-id="element-299">
          <h1 className="text-2xl font-bold text-navy-900" data-id="element-300">
            Gerenciamento de Produtos
          </h1>
          <p className="text-slate-500 mt-1" data-id="element-301">
            Monitore e ajuste preços de {products.length} produtos ativos
          </p>
        </div>
        <div className="flex gap-3 w-full md:w-auto" data-id="element-302">
          <div className="relative flex-1 md:w-64" data-id="element-303">
            <input type="text" placeholder="Buscar produto..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-navy-900 focus:border-transparent" data-id="element-304" />
            <Search className="absolute left-3 top-2.5 h-4 w-4 text-slate-400" data-id="element-305" />
          </div>
          <button className="flex items-center px-4 py-2 bg-white border border-slate-200 rounded-lg text-sm font-medium text-slate-700 hover:bg-slate-50" data-id="element-306">
            <Filter className="h-4 w-4 mr-2" data-id="element-307" />
            Filtros
          </button>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden" data-id="element-308">
        <div className="overflow-x-auto" data-id="element-309">
          <table className="w-full text-left text-sm" data-id="element-310">
            <thead className="bg-slate-50 text-slate-500 font-medium border-b border-slate-200" data-id="element-311">
              <tr data-id="element-312">
                <th className="px-6 py-4 cursor-pointer hover:text-navy-900" data-id="element-313">
                  Produto <ChevronDown className="inline h-3 w-3 ml-1" data-id="element-314" />
                </th>
                <th className="px-6 py-4" data-id="element-315">Categoria</th>
                <th className="px-6 py-4 text-right" data-id="element-316">Seu Preço</th>
                <th className="px-6 py-4 text-right" data-id="element-317">Média Mercado</th>
                <th className="px-6 py-4 text-right" data-id="element-318">Diferença</th>
                <th className="px-6 py-4 text-center" data-id="element-319">Status</th>
                <th className="px-6 py-4" data-id="element-320"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-321">
              {filteredProducts.map((product, index) => <tr key={product.id} onClick={() => onProductClick(product.id)} className={`group cursor-pointer hover:bg-navy-50 transition-colors ${index % 2 === 0 ? 'bg-white' : 'bg-slate-50/50'}`} data-id="element-322">
                  <td className="px-6 py-4 font-medium text-navy-900 group-hover:text-navy-700" data-id="element-323">
                    {product.name}
                  </td>
                  <td className="px-6 py-4 text-slate-500" data-id="element-324">
                    {product.category}
                  </td>
                  <td className="px-6 py-4 text-right font-medium" data-id="element-325">
                    R${' '}
                    {product.price.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2
                })}
                  </td>
                  <td className="px-6 py-4 text-right text-slate-500" data-id="element-326">
                    R${' '}
                    {product.marketAvg.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2
                })}
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-327">
                    <span className={`font-medium ${product.diff > 0 ? 'text-red-600' : product.diff < 0 ? 'text-emerald-600' : 'text-slate-400'}`} data-id="element-328">
                      {product.diff > 0 ? '+' : ''}
                      {product.diff}%
                    </span>
                  </td>
                  <td className="px-6 py-4 text-center" data-id="element-329">
                    <StatusBadge status={product.status} data-id="element-330" />
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-331">
                    <button className="p-1 hover:bg-slate-200 rounded text-slate-400 hover:text-navy-900" onClick={e => e.stopPropagation()} data-id="element-332">
                      <MoreHorizontal className="h-4 w-4" data-id="element-333" />
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <div className="px-6 py-4 border-t border-slate-200 bg-slate-50 flex justify-between items-center text-sm text-slate-500" data-id="element-334">
          <span data-id="element-335">
            Mostrando {filteredProducts.length} de {products.length} produtos
          </span>
          <div className="flex gap-2" data-id="element-336">
            <button className="px-3 py-1 border border-slate-200 rounded bg-white disabled:opacity-50" disabled data-id="element-337">
              Anterior
            </button>
            <button className="px-3 py-1 border border-slate-200 rounded bg-white hover:bg-slate-50" data-id="element-338">
              Próxima
            </button>
          </div>
        </div>
      </div>
    </motion.div>;
}